/** @jsx h */
import { $$ } from '@3pc/dom';
import { $search, labels } from '../../config';
import { dateFormatter } from '../../helpers/helpers';
import { useState, useRef, useEffect } from 'preact/hooks';
import { Fragment } from 'preact';

const FilterDate = ({ facet, triggerAjaxSubmit, pluginNamespace, isReset }) => {
  const [facetsOptions] = useState(facet.options);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [dateInput, setDateInput] = useState('');
  const dateInputEl = useRef(null);

  function handleChange(e) {
    const dateType = e.target.dataset.datetype;
    if (dateType === 'start') {
      const startDateString = `${e.target.value.replaceAll('-', '')}0000-`;
      setStartDate(startDateString);
    } else {
      const endDateString = `${e.target.value.replaceAll('-', '')}2359`;
      setEndDate(endDateString);
    }
  }

  function onFocus(e) {
    e.target.showPicker();
  }

  // set already selected data in json as default in datepicker inputs
  useEffect(() => {
    const rangeMinSelected = facet.options.rangeMinSelected;
    const rangeMaxSelected = facet.options.rangeMaxSelected;

    if (rangeMinSelected && rangeMaxSelected) {
      const startDateObj = dateFormatter(new Date(rangeMinSelected.date));
      const endDateObj = dateFormatter(new Date(rangeMaxSelected.date));
      const datepickers = $$('[data-datepicker]', $search);

      datepickers.forEach(datepicker => {
        const dateType = datepicker.dataset.datetype;

        if (dateType === 'start') {
          datepicker.value = `${startDateObj.year}-${startDateObj.month}-${startDateObj.day}`;
        } else if (dateType === 'end') {
          datepicker.value = `${endDateObj.year}-${endDateObj.month}-${endDateObj.day}`;
        }
      });

      if (dateInputEl.current) {
        dateInputEl.current.value = `${facet.name}:${startDateObj.year}${startDateObj.month}${startDateObj.day}0000-${endDateObj.year}${endDateObj.month}${endDateObj.day}2359`;
      }
    }
  }, []);

  useEffect(() => {
    // if startDate was set, but not endDate, use rangeMax as endDate
    // else if startDate was NOT set, but endDate was, use rangeMin as startdDate
    if (startDate && !endDate) {
      // check if rangeMaxSelected is set by json, if yes we us that, if not we use the facetOption rangeMax
      const rangeMaxSelected = facet.options.rangeMaxSelected;
      const rangeMax = rangeMaxSelected
        ? rangeMaxSelected.date
        : facetsOptions.rangeMax.date;

      // remove time data from string (after space) and remove unwanted '-'
      const endDateString = rangeMax
        .substring(0, rangeMax.indexOf(' '))
        .replaceAll('-', '');
      const dateString = `${startDate}${endDateString}2359`;

      setDateInput(`${facet.name}:${dateString}`);
    } else if (!startDate && endDate) {
      // check if rangeMaxSelected is set by json, if yes we us that, if not we use the facetOption rangeMax
      const rangeMinSelected = facet.options.rangeMinSelected;
      const rangeMin = rangeMinSelected
        ? rangeMinSelected.date
        : facetsOptions.rangeMax.date;

      // remove time data from string (after space) and remove unwanted '-'
      const startDateString = rangeMin
        .substring(0, rangeMin.indexOf(' '))
        .replaceAll('-', '');
      const dateString = `${startDateString}0000-${endDate}`;

      setDateInput(`${facet.name}:${dateString}`);
    } else if (startDate && endDate) {
      const dateString = `${startDate}${endDate}`;

      setDateInput(`${facet.name}:${dateString}`);
    } else if (isReset) {
      dateInputEl.current.value = '';
      setDateInput('');
    }
  }, [startDate, endDate]);

  useEffect(() => {
    setStartDate('');
    setEndDate('');
  }, [isReset]);

  useEffect(() => {
    if (dateInput) {
      triggerAjaxSubmit();
    }
  }, [dateInput]);

  return (
    <Fragment>
      <input
        className="is-hidden"
        ref={dateInputEl}
        value={dateInput}
        name={dateInput && !isReset ? `${pluginNamespace}[filter][]` : ''}
        data-date-input
      />
      <ul className="filter__list filter__options-inner">
        <li className="filter__item filter__item--flex">
          <label htmlFor="start-date" className="filter__label">
            {labels.faceting.startDate}
          </label>
          <input
            id="start-date"
            type="date"
            className="input--small filter__date"
            onChange={handleChange}
            data-datepicker
            data-datetype="start"
            onFocus={onFocus}
          />
        </li>
        <li className="filter__item filter__item--flex">
          <label htmlFor="end-date" className="filter__label">
            {labels.faceting.endDate}
          </label>
          <input
            id="end-date"
            type="date"
            className="input--small filter__date"
            onChange={handleChange}
            data-datepicker
            data-datetype="end"
            onFocus={onFocus}
          />
        </li>
      </ul>
    </Fragment>
  );
};

export default FilterDate;
